import { apiRequest } from '@zr/utilities/api';

export const API_URL = '/apply/api/interview';

/**
 * Get the next question.
 *
 * @param {string} encResponseId Encrypted response ID.
 * @returns JSON object containing question data.
 */
export async function fetchNextQuestion(encResponseId, options) {
  const apiUrl = `${API_URL}/${encResponseId}`;
  const fetchInit = {
    headers: {
      Accept: 'application/json',
    },
    ...options,
  };

  const response = await apiRequest(apiUrl, fetchInit);
  return response.json();
}

function getPostBody(contentType, questionId, { answers, answerUpload, skipQuestion, numSuggestions } = {}) {
  let body = '';

  if (contentType === 'application/json') {
    let params = { question_id: questionId, answer: answers };

    if (answerUpload) {
      params = { ...params, ...answerUpload };
    }

    if (skipQuestion) {
      params.skip_question = 1; // because Perl ಠ_ಠ
    }

    if (numSuggestions) {
      params.num_suggestions = numSuggestions;
    }

    body = JSON.stringify(params);
  }

  if (contentType === 'application/x-www-form-urlencoded; charset=UTF-8') {
    const params = new URLSearchParams({
      question_id: questionId,
    });

    if (answers) {
      if (Array.isArray(answers)) {
        answers.forEach((answer) => params.append('answer', answer));
      } else {
        params.set('answer', answers);
      }
    }

    if (answerUpload) {
      Object.keys(answerUpload).forEach((key) => params.set(key, answerUpload[key]));
    }

    if (skipQuestion) {
      params.set('skip_question', 1); // because Perl ಠ_ಠ
    }

    if (numSuggestions) {
      params.set('num_suggestions', numSuggestions);
    }

    body = params.toString();
  }

  return body;
}

/**
 * Process answer to a question, and get next question if available.
 *
 * @param {string} encResponseId Encrypted response ID.
 * @param {string} questionId Identifies the question.
 * @param {Object} [params={}] Request parameters.
 * @param {string[]} [params.answers] List of answers to the question.
 * @param {string} [params.answerUpload] Upload data.
 * @param {boolean} [params.skipQuestion] Skip the question.
 * @param {number} [params.numSuggestions] Number of suggestions that will be displayed after the interview.
 * @param {boolean} [contentType=application/json] Content type for HTTP request header.
 * @returns JSON object containing question data if another question is available, otherwise completed.
 */
export async function postAnswer(encResponseId, questionId, {
  answers, answerUpload, skipQuestion, numSuggestions,
} = {}, contentType = 'application/json') {
  const body = getPostBody(contentType, questionId, { answers, answerUpload, skipQuestion, numSuggestions });

  const apiUrl = `${API_URL}/${encResponseId}`;
  const fetchInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': contentType,
    },
    body,
  };

  const response = await apiRequest(apiUrl, fetchInit);
  return response.json();
}
